import React, { createContext, useState, ReactNode } from "react";

interface catalogContextProps {
  selectedCatalog: boolean;
  setSelectedCatalog: React.Dispatch<React.SetStateAction<boolean>>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
}

const CatalogContext = createContext<catalogContextProps>({
  selectedCatalog: false,
  setSelectedCatalog: () => {},
  searchText: "",
  setSearchText: () => {},
});

interface CatalogProviderProps {
  children: ReactNode;
}

export const CatalogProvider = ({ children }: CatalogProviderProps) => {
  const [selectedCatalog, setSelectedCatalog] = useState(false);
  const [searchText, setSearchText] = useState<string>("");

  return (
    <CatalogContext.Provider
      value={{ selectedCatalog, setSelectedCatalog, searchText, setSearchText }}
    >
      {children}
    </CatalogContext.Provider>
  );
};

export default CatalogContext;
